export { LoggedOutOrNoJiraProductTourOverview } from "./jira-software-logged-out-page.template";
export { LoggedOutOrNoJiraProductTourOverview as default } from "./jira-software-logged-out-page.template";
